export const SEO_CONFIG = {
    title: {
      maxLength: 80,
      helpText: "حداکثر 80 کاراکتر مجاز است"
    },
    description: {
      maxLength: 180,
      helpText: "حداکثر 180 کاراکتر مجاز است"
    }
  };